import React from "react";
import ReactDOM from "react-dom/client";

import "./styles/index.css";
import App from "./App.tsx";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { AuthProvider } from "./AuthProvider";
/**
 * Initialize a PublicClientApplication instance which is provided to the MsalProvider component
 * We recommend initializing this outside of your root component to ensure it is not re-initialized on re-renders
 */
const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
const router = createBrowserRouter([
  {
    path: "*",
    element: <App />,
  },
]);

/**
 * We recommend wrapping most or all of your components in the MsalProvider component. It's best to render the MsalProvider as close to the root as possible.
 */
(async () => {
  await msalInstance.initialize();
  root.render(
    // <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <Provider store={store}>
            <RouterProvider router={router} />
          </Provider>
        </AuthProvider>
      </MsalProvider>
    // </React.StrictMode>
  );
})();
